"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var normalizePhoneNumber = function normalizePhoneNumber(phoneNumber) {
  var newPhoneNumber = (phoneNumber || "").replace(/\D/g, "");

  if (newPhoneNumber.length === 10) {
    newPhoneNumber = "+1".concat(newPhoneNumber);
  } else if (newPhoneNumber.length > 10) {
    newPhoneNumber = "+".concat(newPhoneNumber);
  } else {
    newPhoneNumber = null;
  }

  return newPhoneNumber;
};

var _default = normalizePhoneNumber;
exports["default"] = _default;